import { ref, watch } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import type { WorkspaceItem } from '@/types/workspace'
import { useWorkspaceList } from '@/composables/useWorkspaceList'
import { session } from '@/composables/useSession'

const activeWorkspace = ref<WorkspaceItem | null>(null)
const [workspaces] = useWorkspaceList()

watch(
  () => workspaces.value,
  () => {
    if (activeWorkspace.value) return
    activeWorkspace.value = workspaces.value?.find((ws) => ws.id === session.workspace.id) || null
  },
  {
    once: true,
  },
)

export default createSharedComposable(() => {
  const submittedWorkspace = ref<WorkspaceItem | null>(null)

  function resetWorkspace() {
    activeWorkspace.value = workspaces.value?.find((ws) => ws.id === session.workspace.id) || null
    submittedWorkspace.value = null
  }

  function revertWorkspace() {
    activeWorkspace.value = submittedWorkspace.value
      ? submittedWorkspace.value
      : workspaces.value?.find((ws) => ws.id === session.workspace.id) || null
  }

  function submitWorkspace() {
    submittedWorkspace.value = activeWorkspace.value
  }

  return {
    submitWorkspace,
    activeWorkspace,
    resetWorkspace,
    revertWorkspace,
  }
})
